import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FmdGoodIcon(props: IconProps) {
    return <Icon {...props} iconKey={"fmd_good"}/>
}
